module.exports = __webpack_public_path__ + "media/images/pillar_programmatic-ads-a803771d23f96fedf13c33ffa76c6583.jpg";